import { validateLatitude, validateLongitude } from 'libraries/module/formbuilder/validators/coordinatesValidator';
/**
 * coordinates Group
 * @param fb : FormBuilder
 */
export function coordinatesGroup (fb: any) {
    return fb.group({
        latitude: ['', validateLatitude()],
        longitude: ['', validateLongitude()],
    });
}
